// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceLightningBolt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.271 3.849-2.956 9.244h2.541c.672 0 1.205.517 1.163 1.13l-.274 4.001 5.421-6.98h-1.861c-.841 0-1.405-.787-1.068-1.49L16.07 3.85zM8.506 2.765C8.651 2.312 9.107 2 9.626 2h7.761c.84 0 1.405.787 1.068 1.49l-2.833 5.905h2.21c.946 0 1.498.974.952 1.678l-8.137 10.476c-.678.874-2.187.388-2.114-.681l.406-5.926H6.166c-.777 0-1.336-.68-1.119-1.361z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceLightningBolt;
